import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";
// import {
//   pastDateOnlyValidation,
//   pastDateWithTodayValidation,
//   futureDateWithTodayValidation,
// } from "@validations/utils";

const QUALIFICATION = FORM_FIELDS.EMPLOYEE.QUALIFICATION;

export const EDUCATION = QUALIFICATION.EDUCATION;
export const LOCAL_TRAINING = QUALIFICATION.LOCAL_TRAINING;
export const FOREIGN_TRAINING = QUALIFICATION.FOREIGN_TRAINING;
export const ADDITIONAL_PROFESSIONAL_QUALIFICATION =
  QUALIFICATION.ADDITIONAL_PROFESSIONAL_QUALIFICATION;
export const PUBLICATION = QUALIFICATION.PUBLICATIONS;
export const HONOURS = QUALIFICATION.HONOURS;
export const REWARDS = QUALIFICATION.REWARDS;

export const educationValidation = yup.object().shape({
  [EDUCATION.NAME_OF_INSTITUTION]: yup
    .string()
    .required("Name of Institution is required"),
    // .max(50, "No longer than 50 character"),
  [EDUCATION.SUBJECT]: yup
    .string(),
    // .required("Subject is required")
    // .max(50, "No longer than 50 character"),
  [EDUCATION.DEGREE]: yup.string(),
  // .max(50, "No longer than 50 character"),
  [EDUCATION.PASSING_YEAR]: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    // .required("Passing Year is required")
    .typeError("Passing Year has to be a number")
    .integer("Passing Year cannot have decimal values")
    .positive("Passing Year cannot be negative")
    .max(9999, "No longer than 4 character"),
  // [EDUCATION.UPLOAD_CERTIFICATE]: yup
  //   .object()
  //   .shape({
  //     id: yup.number(),
  //     name: yup.string(),
  //     mimeType: yup.string(),
  //     fileId: yup.string(),
  //     documentId: yup.string(),
  //     documentType: yup.string(),
  //   })
  //   .nullable(),
});

export const localTrainingValidation = yup.object().shape({
  [LOCAL_TRAINING.COURSE_TITLE]: yup
    .string()
    .required("Course Title is required"),
    // .max(50, "No longer than 50 character"),
  [LOCAL_TRAINING.INSTITUTION]: yup
    .string(),
    // .required("Institution is required")
    // .max(50, "No longer than 50 character"),
  [LOCAL_TRAINING.POSITION]: yup
    .string(),
    // .required("Position is required")
    // .max(50, "No longer than 50 character"),
  // [LOCAL_TRAINING.FROM_DATE]: yup.string(),
  // .test("validator-from-date", pastDateOnlyValidation)
  // .required("From Date is required"),
  // [LOCAL_TRAINING.TO_DATE]: yup.string(),
  // .test("validator-to-date", futureDateWithTodayValidation)
  // .required("To Date is required"),
  // [LOCAL_TRAINING.UPLOAD_CERTIFICATE]: yup
  //   .object()
  //   .shape({
  //     id: yup.number(),
  //     name: yup.string(),
  //     mimeType: yup.string(),
  //     fileId: yup.string(),
  //     documentId: yup.string(),
  //     documentType: yup.string(),
  //   })
  //   .nullable()
  // .required("Document is required"),
});

export const foreignTrainingValidation = yup.object().shape({
  [FOREIGN_TRAINING.COURSE_TITLE]: yup
    .string()
    .required("Course Title is required"),
    // .max(50, "No longer than 50 character"),
  [FOREIGN_TRAINING.COUNTRY]: yup
    .number()
    .typeError("Country is required")
    .required("Country is required"),
  [FOREIGN_TRAINING.POSITION]: yup
    .string(),
    // .required("Position is required")
    // .max(50, "No longer than 50 character"),
  [FOREIGN_TRAINING.FROM_DATE]: yup.string(),
  // .test("validator-from-date", pastDateOnlyValidation)
  // .required("From Date is required"),
  [FOREIGN_TRAINING.TO_DATE]: yup.string(),
  // .test("validator-to-date", futureDateWithTodayValidation)
  // .required("To Date is required"),
  // [FOREIGN_TRAINING.UPLOAD_CERTIFICATE]: yup
  //   .object()
  //   .shape({
  //     id: yup.number(),
  //     name: yup.string(),
  //     mimeType: yup.string(),
  //     fileId: yup.string(),
  //     documentId: yup.string(),
  //     documentType: yup.string(),
  //   })
  //   .nullable(),
  // .required("Document is required"),
});

export const additionalProfessionalQualificationValidation = yup
  .object()
  .shape({
    [ADDITIONAL_PROFESSIONAL_QUALIFICATION.QUALIFICATION]: yup
      .string()
      .required("Qualification is required"),
    // [ADDITIONAL_PROFESSIONAL_QUALIFICATION.UPLOAD_DOCUMENT]: yup
    //   .object()
    //   .shape({
    //     id: yup.number(),
    //     name: yup.string(),
    //     mimeType: yup.string(),
    //     fileId: yup.string(),
    //     documentId: yup.string(),
    //     documentType: yup.string(),
    //   })
    //   .nullable(),
  });

export const publicationValidation = yup.object().shape({
  [PUBLICATION.BOOK]: yup
    .string()
    .required("Book is required"),
    // .max(50, "No longer than 50 character"),
  [PUBLICATION.JOURNAL]: yup
    .string(),
    // .required("Journal is required")
    // .max(50, "No longer than 50 character"),
  [PUBLICATION.DESCRIPTION]: yup.string(),
  // .required("Description is required"),
  [PUBLICATION.DATE]: yup.string(),
  // .test("validator-date", pastDateWithTodayValidation)
  // .required("Date is required"),
  // [PUBLICATION.UPLOAD_DOCUMENT]: yup
  //   .object()
  //   .shape({
  //     id: yup.number(),
  //     name: yup.string(),
  //     mimeType: yup.string(),
  //     fileId: yup.string(),
  //     documentId: yup.string(),
  //     documentType: yup.string(),
  //   })
  //   .nullable(),
});

export const honoursValidation = yup.object().shape({
  [HONOURS.HONORARIUM]: yup.string().required("Honorarium is required"),
  [HONOURS.GROUND]: yup.string(),
  // .required("Ground is required"),
  [HONOURS.DATE]: yup.string(),
  // .test("validator-date", pastDateWithTodayValidation)
  // .required("Date is required"),
});

export const rewardValidation = yup.object().shape({
  [REWARDS.NAME]: yup.string().required("Name is required"),
  // [REWARDS.DESCRIPTION]: yup.string().required("Description is required"),
  // [REWARDS.UPLOAD_DOCUMENT]: yup
  //   .object()
  //   .shape({
  //     id: yup.number(),
  //     name: yup.string(),
  //     mimeType: yup.string(),
  //     fileId: yup.string(),
  //     documentId: yup.string(),
  //     documentType: yup.string(),
  //   })
  //   .nullable(),
});

export type EducationsFormDataType = yup.InferType<typeof educationValidation>;
export type LocalTrainingsFormDataType = yup.InferType<
  typeof localTrainingValidation
>;
export type ForeignTrainingsFormDataType = yup.InferType<
  typeof foreignTrainingValidation
>;
export type AdditionalProfessionalQualificationsFormDataType = yup.InferType<
  typeof additionalProfessionalQualificationValidation
>;
export type PublicationsFormDataType = yup.InferType<
  typeof publicationValidation
>;
export type HonoursFormDataType = yup.InferType<typeof honoursValidation>;
export type RewardsFormDataType = yup.InferType<typeof rewardValidation>;
